import { useEffect, useState } from 'react'
import { wsManager, type WsStatus } from '@/services/websocket'

/** Live WebSocket connection status for header badge. */
export function useWsStatus(): WsStatus {
  const [status, setStatus] = useState<WsStatus>(() => wsManager.getStatus())

  useEffect(() => wsManager.onStatus(setStatus), [])

  return status
}
